<template>
  <div class="login-main"  v-if="openFlag">
    <!-- 用户登陆隐藏界面 -->
    <div @click="close" class="login-dialog" style="width: 100%;height: 100%;position: fixed;">
      <el-form :model="fromData" label-width="80px">
        <div class="login-shade" @click.stop="loginShadeClick">
          <div class="el-dialog">
            <div class="el-dialog-header" @click="close">
              <i class="iconfont"><img src="@/static/icon/close.svg"></i>
            </div>
            <div class="el-dialog-body">
              <div class="title">
                <a href="#">
                  <img src="@/static/img/logo-hutil.png">
                </a>
              </div>
              <div class="form-box">
                <div class="input input-password">
                  <el-input v-model="fromData.username">
                    <template slot="prepend">账号</template>
                  </el-input>
                </div>
                <div class="input input-password">
                  <el-input v-model="fromData.password" show-password>
                    <template slot="prepend">密码</template>
                  </el-input>
                </div>
                <!--            <div class="scroll" v-on:mousedown="scrollMouseDown">
                              <div class="scroll-block">&gt;</div>
                              <div class="scroll-bg"></div>
                              <div class="scroll-text">请按住滑块，拖动至最右 👉</div>
                              <div class="scroll-text-opt">验证通过</div>
                            </div>-->
                <div class="login-user">
                  <div class="login-user-left">
                    <el-checkbox>记住密码</el-checkbox>
                    <a href="#">忘记密码？</a>
                  </div>
                  <div class="login-user-right">
                    <div class="user-login">
                      <el-link class="register-btn" :underline="false">注册</el-link>
                      <el-link class="login-btn" :underline="false" @click="loginClick">登录</el-link>
                    </div>
                  </div>
                </div>
                <div class="line"></div>
                <div class="text-align-center">
                  其他登录方式
                </div>
                <div class="other-login">
                  <a href="#">
                    <i class="iconfont"><img src="@/static/icon/zfb.svg"></i>
                  </a>
                  <a href="#">
                    <i class="iconfont"><img src="@/static/icon/weixin.svg"></i>
                  </a>
                  <a href="#">
                    <i class="iconfont"><img src="@/static/icon/weibo.svg"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="masking"></div>
  </div>

</template>

<script>
import { login } from '@/api/userApi'

export default {
  name: "h-login",
  props: {
    openFlag: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      phone: '',
      fromData:{

      }
    }
  },
  watch:{
    'openFlag'(newValue, oldValue) {
      if(newValue){
        this.fromData = {};
      }
    },
  },
  mounted() {
  },
  methods: {
    /**
     * 登录按钮
     */
    loginClick(){
      const $this = this;
      const store = this.$store;
      if($this.fromData.username && $this.fromData.password){
        $this.$store.commit('setLoading', true);
        $this.$store.dispatch('login',$this.fromData).then((res)=>{
          $this.close();
          $this.$store.dispatch('getInfo');
        }).catch(err=>{
          $this.$message({
            message: err.msg,
            type: 'error'
          });
        }).finally(()=>{
          $this.$store.commit('setLoading', false);
        })
      }else {
        this.$message({
          message: '请输入账号密码',
          type: 'warning'
        });
      }
    },
    close(){
      this.$emit('close');
    },
    loginShadeClick(){

    }
  }
}
</script>

<style scoped>
.masking{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);

}
.login-dialog{
  z-index: 2;
}
.login-shade {
  position: fixed;
  width: 30%;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all .5s;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.login-shade .el-dialog {
  width: 100%;
  height: 100%;
  position: absolute;
  transition: all .5s;
  top: 50%;
  left: 50%;
  /*background: rgba(0, 0, 0, 0.9);*/
  transform: translate3d(-50%, -50%, 0);
}

.login-shade .el-dialog-header {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 20px;
  text-align: right;
}

.login-show .el-dialog {
  transform: translate3d(-50%, -50%, 0);
}

.el-dialog-header .icon-cuowu {
  cursor: pointer;
  font-size: 20px;
  transition: all .5s;
  color: #8e8787;
}

.el-dialog-header .icon-cuowu:hover {
  color: #655e5e;
}

.el-dialog-body {
  width: 100%;
  height: 100%;
}

.el-dialog-body .title {
  padding: 40px 0;
  width: 100%;
  height: 127px;
}

.el-dialog-body .title img {
  margin: 0 auto;
  display: block;
  height: 47px;
}

.el-dialog-body .form-box {
  padding: 0 20px;
  width: 100%;
  /*height: 100%;*/
  box-sizing: border-box;
}

.form-box .input {
  margin-bottom: 10px;
  width: 100%;
  height: 60px;
  line-height: 60px;
  position: relative;
}

.form-box input:hover {
  border: 1px solid #e5e5e5;
}

.form-box input {
  padding: 23px 15px 23px 70px;
  width: 100%;
  height: 60px;
  outline: none;
  border: 1px solid transparent;
}

.form-box .el-input__inner {
  position: absolute;
  top: 2px;
  left: 10px;
  width: 58px;
  height: 20px;
  font-size: 14px;
  display: inline-block;
  color: #8e8787;
}

.form-box .input-password input {
  line-height: 14px;
  padding: 23px 15px;
  padding-right: 120px;
}

.form-box .remember {
  position: absolute;
  top: 0;
  right: 20px;
}

.form-box .remember label {
  font-size: 14px;
  color: #8e8787;
}

.form-box #radio {
  width: 14px;
  height: 14px;
  vertical-align: -2px;
  background-color: #fd281a;
  border-color: #fd281a;
  border-radius: 100%;
}

.form-box #radio:focus + label {
  color: #292525;
}

.form-box .scroll {
  position: relative;
  margin-bottom: 40px;
  width: 100%;
  height: 60px;
  background: #f5f5f5;
}

.form-box .tran {
  transition: all .5s;
}

.form-box .scroll-block {
  position: absolute;
  left: 0;
  width: 60px;
  height: 60px;
  background: #292525;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 5;
}

.form-box .scroll-block:active {
  cursor: move;
}

.form-box .scroll-bg {
  position: absolute;
  height: 60px;
  background: #8e8787;
  z-index: 4;
}

.form-box .scroll-text,
.form-box .scroll-text-opt {
  position: absolute;
  line-height: 60px;
  font-size: 14px;
  width: 360px;
  height: 60px;
  text-align: center;
  color: #655e5e;
}

.form-box .scroll-text-opt {
  color: #333;
  opacity: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all .5s;
}

.form-box .scroll-text-opt .opt {
  opacity: 1;
}

.form-box .login-user {
  width: 100%;
  height: 29px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form-box .login-user a {
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  letter-spacing: .1em;
  color: #655e5e;
}

.form-box .login-user-left a {
  margin-left: 10px;
}

.form-box .login-user-right a, .form-box .login-user-right button {
  padding: 5px 12px;
  border-radius: 24px;
  background: #f5f5f5;
  color: #655e5e;
}

.form-box .login-user-right .register-btn{
  background-color: #3498db; color: #fff;
}

.form-box .login-user-right .login-btn{
  background-color: #2ecc71; color: #fff;
  margin-left: 10px;
}

.form-box .line {
  margin: 20px;
  width: 100%;
  height: 1px;
  background: #e5e5e5;
}

.form-box .text-align-center {
  margin-bottom: 10px;
  height: 19px;
  color: #8e8787;
  font-size: 14px;
  text-align: center;
}

.form-box .other-login {
  padding: 10px 20px 30px;
  height: 84px;
  display: flex;
  justify-content: center;
}

.form-box .other-login a {
  margin: 0 10px;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/*.form-box .other-login a:nth-child(1) {
  background: #06f;
}

.form-box .other-login a:nth-child(2) {
  background: #6f0;
}

.form-box .other-login a:nth-child(3) {
  background: #fd281a;
}*/

.form-box .other-login i {
  font-size: 24px;
  color: #fff;
}

.form-box .other-login i {
  font-size: 24px;
  color: #fff;
}
</style>
